import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Slider from '@wix/da-ds/pkg/Slider';
import { getSliderConfiguration } from '@wix/da-ds/pkg/Slider/helpers';
import { BREAKPOINTS as breakpoints } from '@wix/da-ds/pkg/Slider/constants';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
const MeasuredSlider = (_param)=>{
    var { children, renderSliderItems } = _param, restProps = _object_without_properties(_param, [
        "children",
        "renderSliderItems"
    ]);
    const { width: screenWidth } = useContext(ScreenSizeContext);
    const isMobile = useContext(MobileContext);
    const { ref, dimensions } = useMeasureElementCookie(MeasuredCookieType.SLIDER, {
        cookieDim: 'width'
    });
    const { elementWidth, elementHeight } = getSliderConfiguration({
        breakpoints,
        screenWidth,
        containerWidth: dimensions.width,
        dontScale: isMobile
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, /*#__PURE__*/ React.createElement(Slider, restProps, renderSliderItems({
        width: elementWidth,
        height: elementHeight
    })));
};
MeasuredSlider.displayName = 'MeasuredSlider';
export default MeasuredSlider;

//# sourceMappingURL=MeasuredSlider.js.map